
<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>

<div *ngIf="!bShowUserDetailsScreen">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
        <c-container fluid>
            <div class="row row-cols-auto">
                <div class="col-sm-auto">
                    <button cButton type="button" (click)="enableCreateCustomerForm()">
                    Create Portal User
                    </button>
                </div>
            </div>
        </c-container>
    </c-navbar>

    <c-smart-table
        [columnSorter]="true"
        [columns]="columns"
        [columnFilter]="true"
        [itemsPerPageSelect]="true"
        [itemsPerPage]="15"
        [items]="usersData"
        [tableBodyProps]="{ align: 'middle' }"
        [tableProps]="{ hover: true, striped: true, responsive: true }"
        (rowClick)="rowSelected($event)"
        clickableRows
        header
        pagination>
        <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
        <td>
            <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchCase="'isApproved'">
                    <c-badge [color]="getStatusBadge(item)">
                    {{(getUserStatus(item))}}
                    </c-badge>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    {{tdContent}}
                </ng-container>
            </ng-container>
        </td>
        </ng-template>
    </c-smart-table>
</div>


<div *ngIf="bShowUserDetailsScreen">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      {{portalUserName}}
      <button [cNavbarToggler]="toolbarCollapseRef"></button>
      <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
        <c-navbar-nav class="me-auto mb-2 mb-lg-0">
          
        </c-navbar-nav>
        <form cForm class="d-flex" role="search">
          <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="goBackToSearchScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
          <button cBgColor="danger" *ngIf="!bNewUser && !bUserRejected && bUserActive" cTooltip="Deactivate User" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="deactivateUserPrompt()"><svg cIcon name="cilUserX"></svg></button>
          <button cBgColor="success" *ngIf="!bNewUser && !bUserRejected && !bUserActive" cTooltip="Activate User" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="activateUserPrompt()"><svg cIcon name="cilUserX"></svg></button>
          <button cTooltip="Reset Password" *ngIf="!bNewUser" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="resetPasswordPrompt()"><svg cIcon name="cilHistory"></svg></button>
          <button cTooltip="Edit User" cTooltipPlacement="top" *ngIf="bViewOnly" style="margin: 5px;" cButton (click)="enableEdit()"><svg cIcon name="cilPencil"></svg></button>
          <button cTooltip="Save User" cTooltipPlacement="top" *ngIf="!bViewOnly" style="margin: 5px;" cButton (click)="saveUserPrompt()"><svg cIcon name="cilSave"></svg></button>
        </form>
      </div>
    </c-container>
  </c-navbar>

  <div class="container">
    <form 
        cForm 
        [formGroup]="userform"
        class="needs-validation"
        [gutter]="3"
        novalidate>
        <div class="row pt-2 gx-5">
            <div class="col-6">
                <div class="row">
                    <label cLabel for="inputName">Name</label>
                </div>
                <div class="row">
                    <input [valid]="userNameValid" cFormControl id="inputName" type="text" formControlName="userName" />
                    <c-form-feedback [valid]="userNameValid">{{isUserNameValid()}}</c-form-feedback>
                </div>
            </div>
            <div class="col-6">
                <div class="row">
                    <label cLabel for="inputEmail">Email</label>
                </div>
                <div class="row">
                    <input maxlength="50" [valid]="userEmailValid" cFormControl id="inputEmail" type="text" formControlName="userEmail" />
                    <c-form-feedback [valid]="userEmailValid">{{isUserEmailValid()}}</c-form-feedback>
                </div>
            </div>
        </div>
        <div class="row pt-2 gx-5">
            <div class="col-6">
                <div class="row">
                    <label cLabel for="inputMobile">Mobile</label>
                </div>
                <div class="row">
                    <input [valid]="userMobileValid" cFormControl id="inputMobile" type="text" formControlName="userMobile" />
                    <c-form-feedback [valid]="userMobileValid">{{isUserMobileValid()}}</c-form-feedback>
                </div>
            </div>
            <div class="col-6">
                <div class="row">
                    <label cLabel for="inputRole">Role</label>
                </div>
                <div class="row">
                    <select [valid]="userRoleValid" cSelect id="inputRole" name="inputRole" formControlName="userRole">
                        <option>Customer Approver</option>
                        <option>Customer Creator</option>
                        <option>Retail Admin</option>
                        <option>Super Admin</option>
                        <option>Super Admin Checker</option>
                        <option>Support</option>
                        <option>Compliance</option> 
                    </select>
                    <c-form-feedback [valid]="userRoleValid">{{isuserRoleValid()}}</c-form-feedback>
                </div>
            </div>
        </div>
    </form>
  </div>
</div>